<template>
    <div class="autocomplete">
        <!--
        <el-select v-model="valueAutocomplete" :multiple="multiple" clearable filterable remote reserve-keyword placeholder="Veuillez entrer un mot-clé" no-data-text="pas de résultat trouver" :remote-method="getRemote" :loading="loading">
            <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value">
                <template v-if="item.picture">
                    <img :src="item.picture" alt="..." class="picture rounded-circle"> {{ item.label }}
                </template>
                <template v-if="item.user">
                    {{ item.label }} /
                    <img :src="item.user.picture" alt="..." class="picture rounded-circle"> {{ item.user.fullname }}
                </template>
            </el-option>
        </el-select>
        -->
        <el-autocomplete ref="autocomplete" popper-class="autocomplete-search" v-model="valueAutocomplete" :fetch-suggestions="getRemote" placeholder="Recherche ..." @select="handleSelect">
            <i class="fe fe-search" slot="suffix"></i>
            <template slot-scope="{ item }">
                <div :class="['type-'+item.type, 'autocomplete-item']">
                    <div class="small type">
                        <span v-if="!item.href" class="text-muted">
                            {{ item.typeLabel }}
                        </span>

                        <div v-if="item.href">
                            <a :href="item.href">{{ item.label }}</a>
                        </div>
                        <i :class="icon" class="icon-info text-info" v-for="(icon, index) in item.icons" :key="index"></i>
                    </div>
                    <div class="info-right text-muted small" v-if="item.type == 'vehicule'">
                        <span v-html="$options.filters.highlight('Marque : '+item.brand_name, valueAutocomplete)"></span>
                    </div>
                    <div class="info-right text-muted small" v-if="item.type == 'product'">
                        <span v-if="item.shop_id" v-html="$options.filters.highlight('SID : '+item.shop_id, valueAutocomplete)"></span>
                        <span v-if="item.external_ref" v-html="$options.filters.highlight('REF : '+item.external_ref, valueAutocomplete)"></span>
                        <span v-html="$options.filters.highlight('Code barre : '+item.ean13, valueAutocomplete)"></span>
                    </div>
                    <span v-if="!item.href" class="lable" v-html="$options.filters.highlight(item.label, valueAutocomplete)"></span>
                </div>
            </template>
        </el-autocomplete>
    </div>
</template>
<script>
import { EventBus } from '../event-bus';
import { updateQueryStringParameter } from '../utils/url';
export default {
    data() {
        return {
            loading: false,
            options: []
        };
    },
    computed: {
        valueAutocomplete: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    props: {
        value: {
            required: true
        },
        route: {
            type: String,
            required: true
        },
        query: {
            type: Object,
            default() {
                return {};
            }
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        route(nV, oV) {
            if (nV != oV) {
                this.getRemote(this.value, () => {});
            }
        }
    },
    mounted() {
        //this.getRemote(this.value, true);
        EventBus.$on('search-input.submit', () => {
            this.clear();
        });
    },
    methods: {
        getRemote(query, cb) {
            if (!query || query.length < 3) {
                cb([]);
                return;
            }
            axios
                .get(this.route, { params: { ...this.params, query } })
                .then(r => {
                    var goodloc = updateQueryStringParameter(
                        window.location.href,
                        'q',
                        query
                    );

                    goodloc = updateQueryStringParameter(
                        goodloc,
                        'scope',
                        'name'
                    );
                    goodloc = updateQueryStringParameter(goodloc, 'page', '1');
                    r.data.data.unshift({
                        href: goodloc,
                        label: 'Voir tous les résultats dans le titre',
                        type: 'cta'
                    });
                    goodloc = updateQueryStringParameter(
                        goodloc,
                        'scope',
                        'all'
                    );
                    r.data.data.unshift({
                        href: goodloc,
                        label: 'Voir tous les résultats',
                        type: 'cta'
                    });
                    cb(r.data.data);
                })
                .catch(() => {})
                .then(() => {});
        },
        handleSelect(value) {
            this.$refs.autocomplete.close();
            this.$emit('selected', value);
        },
        clear() {
            this.$refs.autocomplete.close();
        }
    },
    filters: {
        highlight(value, query) {
            var regex = new RegExp('(' + query + ')', 'gim');
            return value.replace(regex, '<span class="highlight">$1</span>');
        }
    }
};
</script>
<style lang="scss" >
.autocomplete {
    .picture {
        width: 25px;
        height: 25px;
        margin-right: 10px;
    }
    .el-autocomplete {
        width: 100%;
        .el-input__suffix {
            display: flex;
            align-items: center;
        }
    }
}
.autocomplete-search {
    width: 400px !important;
    .el-autocomplete-suggestion__wrap {
        padding: 0px;
    }
    li {
        position: relative;
        padding: 0px;
        .autocomplete-item {
            border-left: 2px solid grey;
            border-bottom: 1px solid rgba(0, 40, 100, 0.12);
            padding: 0 5px;
            &.type-product {
                border-left-color: #5cba2f;
            }
            &.type-category {
                border-left-color: #f1c436;
            }
            &.type-manufacturer {
                border-left-color: #467ccb;
            }
            &.type-brand {
                border-left-color: #cd2226;
            }
            .info-right {
                position: absolute;
                right: 3px;
                top: 1px;
            }
            .type {
                .icon-info {
                    margin-left: 5px;
                }
            }
        }
    }
    .highlight {
        font-weight: bold;
    }
}
</style>
